module.exports = __webpack_public_path__ + "34736292/img/comment-question-icon.7dd26e04.svg";